<template>
  <layout>
    <div slot="content">
      <i-card title="集合地点配置">
        <div slot="content">
          <div style="margin-bottom:16px;">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openDialog()">新增集合地点</el-button>
          </div>

          <el-table :data="list" size="small" border v-loading="loading" style="width:100%">
            <el-table-column label="ID" prop="id" width="80"></el-table-column>
            <el-table-column label="集合地点名称" prop="name" min-width="140"></el-table-column>
            <el-table-column label="详细地址" prop="address" min-width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.address">{{ scope.row.address }}</span>
                <span v-else style="color:#bbb">—</span>
              </template>
            </el-table-column>
            <el-table-column label="坐标" width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.longitude || scope.row.latitude" style="font-size:12px;color:#666">
                  {{ scope.row.longitude }} , {{ scope.row.latitude }}
                </span>
                <span v-else style="color:#bbb">—</span>
              </template>
            </el-table-column>
            <el-table-column label="图片" width="140">
              <template slot-scope="scope">
                <div v-if="scope.row.image_urls && scope.row.image_urls.length" class="image-thumbs">
                  <el-image
                    v-for="(url, i) in scope.row.image_urls.slice(0,3)"
                    :key="i"
                    :src="url"
                    :preview-src-list="scope.row.image_urls"
                    fit="cover"
                    class="thumb"
                  />
                </div>
                <span v-else style="color:#bbb">—</span>
              </template>
            </el-table-column>
            <el-table-column label="排序" prop="sort" width="80"></el-table-column>
            <el-table-column label="状态" width="90">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.status === 1 ? 'success' : 'info'">
                  {{ scope.row.status_name }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="openDialog(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="doDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="page-wrap">
            <el-pagination
              background
              :page-size="15"
              :current-page="pageInfo.current_page"
              layout="prev, pager, next"
              @current-change="changePage"
              :total="pageInfo.total">
            </el-pagination>
          </div>
        </div>
      </i-card>

      <!-- 新增/编辑对话框 -->
      <el-dialog :title="form.id ? '编辑集合地点' : '新增集合地点'" :visible.sync="dialogVisible" width="640px">
        <el-form :model="form" :rules="rules" ref="form" label-width="110px" size="small">
          <el-form-item label="地点名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入集合地点名称"></el-input>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input
              v-model="form.address"
              type="textarea"
              :rows="2"
              placeholder="请输入详细地址（可填写地标、门牌号等）"
            ></el-input>
          </el-form-item>
          <el-form-item label="坐标">
            <div style="margin-bottom:6px;">
              <i-map :address="mapAddress" @confirm="onPickLocation"/>
            </div>
            <div style="display:flex; gap:8px;">
              <el-input v-model="form.longitude" placeholder="经度 longitude" style="flex:1">
                <template slot="prepend">经度</template>
              </el-input>
              <el-input v-model="form.latitude" placeholder="纬度 latitude" style="flex:1">
                <template slot="prepend">纬度</template>
              </el-input>
            </div>
            <div style="color:#999;font-size:12px;margin-top:4px;">
              可点击上方「选择地址」在地图中拾取坐标，也可手动输入经纬度
            </div>
          </el-form-item>
          <el-form-item label="图片（可选）">
            <i-upload v-model="form.origin_images" :max-files="6"></i-upload>
            <div style="color:#999;font-size:12px;margin-top:-10px;">最多上传6张集合点实景图，客户端将展示给用户</div>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="form.sort" :min="0" :max="9999" style="width:200px"></el-input-number>
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="form.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="dialogVisible = false" size="small">取消</el-button>
          <el-button type="primary" :loading="saveLoading" @click="doSave" size="small">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
import iMap from '@/components/i-map'

export default {
  name: 'meeting-point-list',
  components: { iMap },
  data() {
    return {
      list: [],
      loading: false,
      pageInfo: { current_page: 1, total: 0 },
      dialogVisible: false,
      saveLoading: false,
      form: this.defaultForm(),
      rules: {
        name: [{ required: true, message: '请输入集合地点名称', trigger: 'blur' }],
      },
    }
  },
  computed: {
    mapAddress() {
      const lng = Number(this.form.longitude)
      const lat = Number(this.form.latitude)
      return {
        position: (lng && lat) ? [lng, lat] : null,
        name: this.form.name || '',
        address: this.form.address || '',
      }
    },
  },
  methods: {
    onPickLocation(picked) {
      if (!picked) return
      if (picked.position && picked.position.length === 2) {
        this.form.longitude = Number(picked.position[0]).toFixed(6)
        this.form.latitude = Number(picked.position[1]).toFixed(6)
      }
      // 拾取到地址后，直接写入到详细地址字段（覆盖原值）；名称完全由用户手动填写，不做联动
      if (picked.address) {
        this.form.address = picked.address
      }
    },
    defaultForm() {
      return {
        id: null,
        name: '',
        address: '',
        longitude: '',
        latitude: '',
        origin_images: [],
        sort: 0,
        status: 1,
      }
    },
    loadList(page = '') {
      this.loading = true
      if (page) this.pageInfo.current_page = page
      this.$http.request('meetingPointList', { page: this.pageInfo.current_page }).then(res => {
        this.list = res.data
        this.pageInfo = res.meta
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    changePage(page) {
      this.pageInfo.current_page = page
      this.loadList()
    },
    openDialog(row) {
      if (row) {
        this.form = {
          id: row.id,
          name: row.name,
          address: row.address || '',
          longitude: row.longitude || '',
          latitude: row.latitude || '',
          origin_images: row.origin_images ? row.origin_images.slice() : [],
          sort: row.sort,
          status: row.status,
        }
      } else {
        this.form = this.defaultForm()
      }
      this.dialogVisible = true
      this.$nextTick(() => { this.$refs.form && this.$refs.form.clearValidate() })
    },
    doSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const images = (this.form.origin_images || []).map(img => img.path)
        const payload = {
          id: this.form.id,
          name: this.form.name,
          address: this.form.address,
          longitude: this.form.longitude === '' ? 0 : Number(this.form.longitude),
          latitude: this.form.latitude === '' ? 0 : Number(this.form.latitude),
          images: images,
          sort: this.form.sort,
          status: this.form.status,
        }
        this.saveLoading = true
        this.$http.request('saveMeetingPoint', payload).then(res => {
          this.saveLoading = false
          if (res.status === 'success') {
            this.dialogVisible = false
            this.$message({ message: '保存成功', type: 'success' })
            this.loadList()
          }
        }).catch(() => { this.saveLoading = false })
      })
    },
    doDelete(id) {
      this.$confirm('确定要删除该集合地点吗？', '提示', { type: 'warning' }).then(() => {
        this.$http.request('deleteMeetingPoint', { id }).then(res => {
          if (res.status === 'success') {
            this.$message({ message: '删除成功', type: 'success' })
            this.loadList()
          }
        })
      })
    },
  },
  created() {
    this.loadList(1)
  },
}
</script>

<style scoped>
.page-wrap {
  margin-top: 20px;
  text-align: center;
}
.image-thumbs {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}
.image-thumbs .thumb {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/meeting-point-list.vue